import { HttpErrorResponse } from '@angular/common/http';
import type { RunTarget } from '../../services/execution-job.service';

export interface StartFehlerText {
  key: string;
  params?: Record<string, string>;
}

/** Erkannt wird die Absage am Code, nicht am Statuscode — wie im Ausfuehren-Dialog. */
export function testlaufStartFehler(error: unknown, target: RunTarget | null): StartFehlerText {
  const code = error instanceof HttpErrorResponse ? error.error?.code : null;
  if (code === 'RUNNER_OFFLINE' && target?.kind === 'runner') {
    return { key: 'testRunExecutions.runnerOffline', params: { name: target.runnerName } };
  }
  if (code === 'NO_MATCHING_RUNNER' && target?.kind === 'labels') {
    return { key: 'testRunExecutions.noMatchingRunner', params: { labels: target.labels.join(', ') } };
  }
  if (code === 'RUNNER_JOB_OPEN') {
    return { key: 'testRunExecutions.jobOpen' };
  }
  return { key: 'testRunExecutions.startError' };
}
